import { createContext } from 'react';

const UserContext = createContext({
  _id: '',
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  rootOrgID: '',
  locale: '',
  Orgs: [
    {
      _id: '',
      name: '',
      path: '',
      logo: '',
      OrgUser: {},
      settings: {
        headerColor: '',
        termsAndConditions: {
          _id: '',
          template: '',
          version: '',
        },
      },
    },
  ],
});

export const UserProvider = UserContext.Provider;
export const UserConsumer = UserContext.Consumer;
export default UserContext;
